import React from "react";
import Layout from "../components/Layout";

import "../assets/css/About.scss";

const About = () => {
  return (
    <Layout>
      <div className="about_content">
        <h1>We are DELTAfoods</h1>
        <div className="section_one section">
          <div className="text_right">
            <h3>Lorem ipsum dolor sit.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis ab impedit id voluptatibus quo iure at possimus
              recusandae esse. Temporibus?
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi
              magnam, eligendi dolor voluptate dolores quisquam magni
              perferendis saepe debitis, blanditiis quae commodi eaque repellat
              atque! Ad at iusto labore distinctio?
            </p>
          </div>
        </div>
        <div className="section_two section">
          <div className="text_left">
            <h3>Lorem ipsum dolor sit.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis ab impedit id voluptatibus quo iure at possimus
              recusandae esse. Temporibus?
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi
              magnam, eligendi dolor voluptate dolores quisquam magni
              perferendis saepe debitis, blanditiis quae commodi eaque repellat
              atque! Ad at iusto labore distinctio?
            </p>
          </div>
        </div>
        <div className="section_three section">
          <div className="text_right">
            <h3>Lorem ipsum dolor sit.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis ab impedit id voluptatibus quo iure at possimus
              recusandae esse. Temporibus?
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi
              magnam, eligendi dolor voluptate dolores quisquam magni
              perferendis saepe debitis, blanditiis quae commodi eaque repellat
              atque! Ad at iusto labore distinctio?
            </p>
          </div>
        </div>
        <div className="section_four section">
          <div className="text_left">
            <h3>Lorem ipsum dolor sit.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Blanditiis ab impedit id voluptatibus quo iure at possimus
              recusandae esse. Temporibus?
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi
              magnam, eligendi dolor voluptate dolores quisquam magni
              perferendis saepe debitis, blanditiis quae commodi eaque repellat
              atque! Ad at iusto labore distinctio?
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;
